import React from "react";
import { connect } from "react-redux";
import { Popup, Button, LoadIndicator } from "devextreme-react";
import { showHideLoadingResume, setSelectedTrabajador, setLoadingResumeData, openCloseModalEditarRoles, setSelectedTab } from "./actions";
import constants from "../../../../../helpers/constants";

const LoadingItem = (props) => (
  <div className={`loading-resume-item ${props.state}`}>
    <div className="icon">
      {props.state === constants.stateLoading && <LoadIndicator id="small-indicator" height={20} width={20} />}
      {props.state === constants.stateSuccess && <div className="material-icons">done</div>}
      {props.state === constants.stateError && <div className="material-icons">clear</div>}
    </div>
    <div className="title">{props.title}</div>
    <div className="detail">{props.detail}</div>
  </div>
);

class LoadingResume extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      showAceptButton: false,
    };
  }
  componentDidUpdate = () => {
    let errorCount = 0;
    let loadingCount = 0;
    let successCount = 0;
    if (this.props.isOpenLoadingResume) {
      Object.keys(this.props.loadingResumeData).forEach((key) => {
        loadingCount += 1;
        if (this.props.loadingResumeData[key].state === constants.stateError) {
          errorCount += 1;
          loadingCount -= 1;
        } else if (this.props.loadingResumeData[key].state === constants.stateSuccess) {
          successCount += 1;
          loadingCount -= 1;
        }
      });

      if (errorCount > 0 && loadingCount === 0) {
        this.setState({ showAceptButton: true });
      } else if (loadingCount > 0) {
        this.setState({ showAceptButton: false });
      } else if (loadingCount === 0 && errorCount === 0 && successCount > 0) {
        setTimeout(() => {
          this.handleAccept();
          this.props.dispatch(setLoadingResumeData({}));
          this.props.dispatch(openCloseModalEditarRoles(false, {}));
          this.props.dispatch(setSelectedTab(this.props.sectionTabs[0]));
        }, 1500);
      }
    }
  }

  isSectionEdited = (idSection) => this.props.selectedTrabajador[idSection] && this.props.selectedTrabajador[idSection].edited

  handleAccept = () => {
    this.props.dispatch(showHideLoadingResume(false));
    const {
      selectedTrabajador,
      loadingResumeData,
    } = this.props;

    const newData = { ...selectedTrabajador };
    this.setState({ showAceptButton: false });

    if (loadingResumeData[constants.idTabAchsVirtual] && loadingResumeData[constants.idTabAchsVirtual].state === constants.stateSuccess) {
      newData.edited = false;
    }
    if (loadingResumeData[constants.idTabAchsGestion] && loadingResumeData[constants.idTabAchsGestion].state === constants.stateSuccess) {
      newData[constants.idTabAchsGestion].edited = false;
    }
    if (loadingResumeData[constants.idTabLGF] && loadingResumeData[constants.idTabLGF].state === constants.stateSuccess) {
      newData[constants.idTabLGF].edited = false;
    }
    if (loadingResumeData[constants.idTabPortalEmpresa] && loadingResumeData[constants.idTabPortalEmpresa].state === constants.stateSuccess) {
      newData[constants.idTabPortalEmpresa].edited = false;
    }

    this.props.dispatch(setSelectedTrabajador(newData));
  }

  render() {
    const {
      selectedTrabajador,
      isOpenModalEditarRoles,
      isOpenLoadingResume,
      loadingResumeData,
    } = this.props;

    if (!isOpenModalEditarRoles) return null;

    return (
      <Popup
        showTitle={false}
        onHiding={this.handleAccept}
        showCloseButton={false}
        closeOnOutsideClick={false}
        height={(Object.keys(loadingResumeData).length * 50) + 90}
        width={420}
        dragEnabled={false}
        visible={isOpenLoadingResume}
        contentComponent={() => (
          <div className="loading-resume-body">

            {selectedTrabajador.edited && (
              <LoadingItem
                title="ACHS Virtual"
                {...loadingResumeData[constants.idTabAchsVirtual]}
              />
            )}

            {this.isSectionEdited(constants.idTabAchsGestion) && (
              <LoadingItem
                title="ACHS Gestion"
                {...loadingResumeData[constants.idTabAchsGestion]}
              />
            )}
            {this.isSectionEdited(constants.idTabLGF) && (
              <LoadingItem
                title="LGF"
                {...loadingResumeData[constants.idTabLGF]}
              />
            )}

            {this.isSectionEdited(constants.idTabPortalEmpresa) && (
              <LoadingItem
                title="Portal Empresa"
                {...loadingResumeData[constants.idTabPortalEmpresa]}
              />
            )}

            {this.state.showAceptButton && (
              <div className="loading-resume-button">
                <Button text="Aceptar" onClick={this.handleAccept} />
              </div>
            )}
          </div>
        )}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  isOpenModalEditarRoles: state.asignacionRoles.isOpenModalEditarRoles,
  selectedTrabajador: state.asignacionRoles.selectedTrabajador,
  isOpenLoadingResume: state.asignacionRoles.isOpenLoadingResume,
  loadingResumeData: state.asignacionRoles.loadingResumeData,
  sectionTabs: state.asignacionRoles.sectionTabs,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(LoadingResume);
